module.exports = __webpack_public_path__ + "img/logo_freja.1a73366e.png";